import { useMutation } from "@tanstack/react-query";
import { RequestError } from "@/axios/schema.ts";
import {
	PhoneAuthTokenResponse,
	verifyPhone2FA,
	VerifyPhone2FAPayload,
} from "@/api/phone-auth.ts";

export default function useVerifyPhone2FA() {
	return useMutation<
		PhoneAuthTokenResponse,
		RequestError,
		{ payload: VerifyPhone2FAPayload }
	>({
		mutationFn: async ({ payload }) => verifyPhone2FA(payload),
	});
}
